import { render, staticRenderFns } from "./third_party_xp.vue?vue&type=template&id=7027fd36&scoped=true&"
import script from "./third_party_xp.vue?vue&type=script&lang=js&"
export * from "./third_party_xp.vue?vue&type=script&lang=js&"
import style0 from "./third_party_xp.vue?vue&type=style&index=0&id=7027fd36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7027fd36",
  null
  
)

export default component.exports